import React from 'react';
import { BookOpenIcon, RadioIcon, UsersIcon } from 'lucide-react';
import { courses, liveSessionTopics } from '../../data/academiaCdv';
export function InsideAcademy() {
  return <section aria-labelledby="dentro-heading" className="px-5 py-16 md:py-24" data-id="element-81" data-mp="cdkbce07bfeg">
      <div className="max-w-6xl mx-auto" data-id="element-82" data-mp="8c8lc7df0s5q">
        <div className="max-w-3xl mb-12" data-id="element-83" data-mp="8bfkto51uyw1">
          <h2 id="dentro-heading" className="font-sans text-2xl md:text-4xl font-bold uppercase leading-tight mb-4" data-id="element-84" data-mp="8el9515utwqp">
            Esto es lo que encontrarás dentro
          </h2>
          <p className="text-lg text-white/70 leading-relaxed" data-id="element-85" data-mp="w1jn9s6i4slg">
            No estás comprando únicamente un curso. Estás entrando a un
            ecosistema donde recibes acompañamiento continuo.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6" data-id="element-86" data-mp="151pzlaqgrmj1">
          {/* Classroom — the core */}
          <article className="lg:col-span-3 rounded-2xl border-2 border-gold-metallic/60 bg-white/[0.03] p-6 md:p-8" data-id="element-87" data-mp="104fzn15g7sgy">
            <div className="flex items-center gap-3" data-id="element-88" data-mp="2m3lhmrp834jk">
              <BookOpenIcon className="h-6 w-6 text-gold-metallic" aria-hidden="true" data-id="element-89" data-mp="2r0vjj6tst8oa" />
              <h3 className="font-sans text-xl md:text-2xl font-bold" data-id="element-90" data-mp="2vzf4b3wnoef2">
                El Classroom
              </h3>
            </div>
            <p className="mt-3 text-white/70 leading-relaxed" data-id="element-91" data-mp="30wygzzdpgj4w">
              El corazón de la Academia. Todo el contenido está organizado para
              que no tengas que adivinar cuál es el siguiente paso. Además de
              las 3 etapas, encontrarás cursos sobre:
            </p>
            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3" data-id="element-92" data-mp="3essrgmu4ngk4">
              {courses.map(course => <li key={course} className="flex gap-3 text-white/85" data-id="element-93" data-mp="3oovq3iprsx2b">
                  <span className="mt-2.5 h-1 w-4 flex-shrink-0 bg-gold-metallic" aria-hidden="true" data-id="element-94" data-mp="3omstgfu445om" />
                  {course}
                </li>)}
            </ul>
          </article>

          <div className="lg:col-span-2 flex flex-col gap-6" data-id="element-95" data-mp="1onp8y8jpx71x">
            {/* Community */}
            <article className="rounded-2xl border border-white/10 p-6 md:p-8" data-id="element-96" data-mp="22ear1v1clcyr">
              <div className="flex items-center gap-3" data-id="element-97" data-mp="1xnkkwfl3l630">
                <UsersIcon className="h-6 w-6 text-gold-metallic" aria-hidden="true" data-id="element-98" data-mp="1xm17qxuqnb5g" />
                <h3 className="font-sans text-xl font-bold" data-id="element-99" data-mp="27ddwvhp5jn7s">La Comunidad</h3>
              </div>
              <p className="mt-3 text-white/70 leading-relaxed" data-id="element-100" data-mp="2lcn1rl7wquwg">
                Interactúas directamente conmigo y con cientos de inversionistas,
                agentes y desarrolladores. Haz preguntas, comparte oportunidades
                y aprende de casos reales todos los días.
              </p>
              <p className="mt-3 text-white leading-relaxed" data-id="element-101" data-mp="mxk6ssdqmbym">
                Muchas veces una sola conversación puede convertirse en una
                alianza o en una operación.
              </p>
            </article>

            {/* Live sessions */}
            <article className="rounded-2xl border border-white/10 p-6 md:p-8" data-id="element-102" data-mp="gu5ombej0yuo">
              <div className="flex items-center gap-3" data-id="element-103" data-mp="32r4g18vurm1">
                <RadioIcon className="h-6 w-6 text-gold-metallic" aria-hidden="true" data-id="element-104" data-mp="82dlklru0s04" />
                <h3 className="font-sans text-xl font-bold" data-id="element-105" data-mp="3p9za74npt0il">
                  Sesiones en vivo cada mes
                </h3>
              </div>
              <ul className="mt-4 flex flex-wrap gap-2" data-id="element-106" data-mp="3ga2e4hyzwzdi">
                {liveSessionTopics.map(topic => <li key={topic} className="rounded-full border border-white/15 px-3 py-1 text-sm text-white/80" data-id="element-107" data-mp="3l8vr89adeod5">
                    {topic}
                  </li>)}
              </ul>
              <p className="mt-3 text-sm text-white/50" data-id="element-108" data-mp="1jh0uczsrwoez">
                …y más temas que iremos agregando.
              </p>
            </article>
          </div>
        </div>
      </div>
    </section>;
}